import type {
  CostOverridesResponse,
  InstancePortfolioCostsResponse,
  SetCostOverrideRequest,
  SetCostOverrideResponse,
} from "@repo/shared/types";
import { del, get, getWithToken, put } from "../_client";

// QL-20 — the advisor's fee overrides on one flow instance.
const BASE = "/internal/flow-instances";

export function listCostOverrides(instanceId: string) {
  return get<CostOverridesResponse>(`${BASE}/${instanceId}/cost-overrides`);
}

export function setCostOverride(instanceId: string, payload: SetCostOverrideRequest) {
  return put<SetCostOverrideResponse>(
    `${BASE}/${instanceId}/cost-overrides`,
    payload satisfies SetCostOverrideRequest,
  );
}

export function clearCostOverride(instanceId: string, overrideId: string) {
  return del<{ success: boolean }>(`${BASE}/${instanceId}/cost-overrides/${overrideId}`);
}

/** The collection's fee rows with the instance's overrides applied. */
export function getInstancePortfolioCosts(instanceId: string) {
  return get<InstancePortfolioCostsResponse>(`${BASE}/${instanceId}/portfolio-costs`);
}

/** The client flow's twin: the instance comes from the session token. */
export function getPublicInstancePortfolioCosts(token: string) {
  return getWithToken<InstancePortfolioCostsResponse>(
    "/public/flow/instance/portfolio-costs",
    token,
  );
}
